export default "__VITE_ASSET__5SSRbFOo__"